/**
 * What deleting a project others have joined actually does, for both delete
 * dialogs (the Projects dropdown's and the project's own): it isn't deleted --
 * the owner leaves and it carries on for the others, with no owner.
 */
export function sharedDeleteMessage(project) {
  const count = project.shared_with || 0;
  const people = count === 1 ? '1 other person' : `${count} other people`;
  return (
    `${people} ${count === 1 ? 'is' : 'are'} working in this project, so it isn't deleted: ` +
    'they keep it and can carry on, with no owner. You lose access, and your own ' +
    `conversations in it are saved to a "${projectFolderName(project)}" folder. ` +
    'To delete it for everyone, remove its members first.'
  );
}

/**
 * What moving a project nobody else has joined to the Recycle Bin does, for
 * the same two dialogs: its conversations go straight to a folder in the
 * regular list, and a restore brings them back with it.
 */
export function recycleBinMessage(project) {
  return (
    `Any conversations in it move to a "${projectFolderName(project)}" folder in your ` +
    'Conversations now. Its files and instructions stay in the Recycle Bin for 30 days: ' +
    'restore it in that time to get everything back, conversations included. After that, ' +
    'its files and instructions are deleted for good.'
  );
}

/** The folder a project's conversations are saved to when they leave it --
 * the backend's _archive_members_conversations names it the same way. */
export function projectFolderName(project) {
  return `Project-${(project.name || 'Untitled').trim()}`.slice(0, 100);
}
